import { combineReducers, Consts } from '../../../dependencies';

import fetchDisposableExport from './fetchDisposableExport';

const { FETCH } = Consts.apiTypes;

export default combineReducers({
    [FETCH]: fetchDisposableExport,
});
